/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsMapMarkerDateV1: {
  name: 'map-marker-date-v1';
  data: string;
} = {
  name: 'map-marker-date-v1',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 10a6 6 0 1 1 12 0h-3V9a1 1 0 1 0-2 0v1h-2V7a1 1 0 1 0-2 0v3H6Zm8 2H6.382c.41 1.164 1.117 2.379 1.964 3.545 1.298 1.787 2.804 3.301 3.654 4.103.85-.802 2.357-2.316 3.654-4.103.847-1.166 1.555-2.381 1.964-3.545H14ZM12 2a8 8 0 0 0-8 8c0 2.369 1.326 4.79 2.728 6.72 1.428 1.968 3.07 3.605 3.954 4.434a1.92 1.92 0 0 0 2.636 0c.884-.83 2.526-2.466 3.954-4.434C18.674 14.79 20 12.37 20 10a8 8 0 0 0-8-8Z" fill="currentColor"/></svg>`,
};
